import window from "common/objects/window";
/**
 * This is used to configure the hidden popup classes used by dropdowns, comboboxes, and date pickers.
 */
export default {
    /**
     * Can a kendo "Popup", not be be confused with PopUpWidget successfully display in "flip" collision mode.
     * @param root The "Popup" anchor.
     * @param height The height the Popup will need.
     * @returns {boolean} True if "flip" collision mode will work without running off the screen.
     */
    suggestFlip: function(root, height) {
        var rect = root.getBoundingClientRect();
        return rect.bottom + height <= window.innerHeight || rect.top - height >= 0;
    },

    /**
     * Configure a kendo "Popup" to use the best possible collision mode. Prefers flip to fit.
     * @param root The popup anchor
     * @param popup The popup widget
     * @param height The popup height
     * @returns {boolean} True if "flip" as possible
     */
    configurePopup: function(root, popup, height) {
        const flip = this.suggestFlip(root, height);
        popup.collisions = flip ? ["flip", "fit"] : ["fit", "fit"];
        return flip;
    }
}
